var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTutorial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.68717C11.8417 7.68717 13.3333 6.19551 13.3333 4.35384C13.3333 2.51217 11.8417 1.02051 10 1.02051C8.15833 1.02051 6.66667 2.51217 6.66667 4.35384C6.66667 6.19551 8.15833 7.68717 10 7.68717ZM10 2.68717C10.9167 2.68717 11.6667 3.43717 11.6667 4.35384C11.6667 5.27051 10.9167 6.02051 10 6.02051C9.08333 6.02051 8.33333 5.27051 8.33333 4.35384C8.33333 3.43717 9.08333 2.68717 10 2.68717ZM10 9.81217C8.03333 7.97884 5.4 6.85384 2.5 6.85384V16.0205C5.4 16.0205 8.03333 17.1455 10 18.9788C11.9667 17.1538 14.6 16.0205 17.5 16.0205V6.85384C14.6 6.85384 11.9667 7.97884 10 9.81217ZM15.8333 14.4622C13.725 14.7455 11.725 15.5455 10 16.8122C8.28333 15.5455 6.275 14.7372 4.16667 14.4538V8.66217C5.91667 8.97884 7.54167 9.78717 8.86667 11.0205L10 12.0872L11.1333 11.0288C12.4583 9.79551 14.0833 8.98717 15.8333 8.67051V14.4622Z",
    fill: "#75748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorial);
export default __webpack_public_path__ + "static/media/tutorial.00ac227f8582f614f6b8001bce6558dc.svg";
export { ForwardRef as ReactComponent };